// Зөвшөөрөл шалгах туслах функцууд

export const isSuperAdmin = (userProfile) => {
  if (!userProfile) return false;
  const roles = userProfile.roles || [];
  return roles.includes("SUPER_ADMIN");
};

export const isActiveUser = (userProfile) => {
  if (!userProfile) return false;
  const status = userProfile.status || "PENDING";
  return status === "ACTIVE";
};

export const isRouteAllowed = (userProfile, path) => {
  if (!userProfile) return false;
  if (isSuperAdmin(userProfile)) return true;
  const allowedRoutes = userProfile.allowedRoutes || [];
  return Array.isArray(allowedRoutes) && allowedRoutes.includes(path);
};

export const canReadCollection = (userProfile, collectionName) => {
  if (!userProfile) return false;
  if (isSuperAdmin(userProfile)) return true;
  const allowed = userProfile.read || [];
  return Array.isArray(allowed) && allowed.includes(collectionName);
};

export const canWriteCollection = (userProfile, collectionName) => {
  if (!userProfile) return false;
  if (isSuperAdmin(userProfile)) return true;
  const allowed = userProfile.write || [];
  return Array.isArray(allowed) && allowed.includes(collectionName);
};
